/**
 * Application entry point
 * Sets up providers and renders the root component
 */
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { QUERY_CACHE_TIME_MS } from './lib/constants';

// Configure React Query with 5-minute cache
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_CACHE_TIME_MS, // 5 minutes
      refetchOnWindowFocus: false, // Don't refetch when window refocuses
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

